import script from "./ProjectMediaCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMediaCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMediaCarousel.vue?vue&type=style&index=0&id=4bd42f41&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd42f41"]])

export default __exports__